import { useState } from "react";

const Example = ({history}) => {
    history.push('/');
    const [test, setTest] = useState([]);


    const Elements = () => {
        return (
            <div>
                {
                    test.map(e => <div>{e}</div>)
                }
            </div>
        );
    }

    const handleIncrement = () =>{
        setTest(e=>[...e,'otro']);
    }

    return (
        <>
            <input type="checkbox" name='test' value='teset'/>
            
            <br/>
            <button type='' onClick={handleIncrement}>increment</button>
            <Elements />
        </>
    );
}
export default Example; //